<dw-router-parent>
  <ng-template>
    <div class="dashboard-designer">
      <header class="designer-header">
        <div>
          <h1>Dashboard Designer</h1>
          <p>Compose dashboards visually, preview with report data, and use JSON for advanced configuration.</p>
        </div>
        <button type="button" class="btn btn-primary" (click)="newConfiguration()">
          <i class="fa fa-plus"></i> New {{ configurationType }}
        </button>
      </header>

      <div class="heading-actions configuration-types">
        <button type="button" *ngFor="let type of configurationTypes"
          class="btn" [class.btn-primary]="configurationType === type.key"
          [class.btn-outline-primary]="configurationType !== type.key"
          (click)="selectConfigurationType(type.key)">
          {{ type.display }}
        </button>
      </div>

      <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="alert alert-success" *ngIf="statusMessage">{{ statusMessage }}</div>

      <div class="designer-layout">
        <aside class="dashboard-list">
          <div class="panel-title">{{ configurationType }}</div>
          <button type="button" *ngFor="let record of records"
            [class.active]="record === selectedRecord"
            (click)="selectRecord(record)">
            <i class="fa fa-code"></i>
            <span>
              <strong>{{ recordDisplay(record) }}</strong>
              <small>{{ recordKey(record) }}</small>
            </span>
            <span class="publish-state" [class.published]="record.IsActive">
              {{ record.IsActive ? 'Active' : 'Inactive' }}
            </span>
          </button>
          <div class="empty-state" *ngIf="!loading && !records.length">No configurations found.</div>
        </aside>

        <main class="designer-workspace" *ngIf="selectedRecord">
          <section class="designer-card">
            <div class="card-heading">
              <div>
                <h2>{{ recordDisplay(selectedRecord) }}</h2>
                <p>Configuration is validated before it is saved.</p>
              </div>
              <div class="heading-actions">
                <span class="editing-pill" *ngIf="configurationType === 'dashboard' && editorMode === 'design'">
                  <i class="fa fa-pencil"></i> Editing
                </span>
                <button type="button" class="btn btn-outline-secondary" [disabled]="loading || saving" (click)="validateConfiguration()">
                  <i class="fa fa-check-circle"></i> Validate
                </button>
                <button *ngIf="configurationType === 'dashboard'" type="button"
                  class="btn btn-outline-primary" [disabled]="loading" (click)="loadPreview()">
                  <i class="fa fa-eye"></i> Preview
                </button>
                <button type="button" class="btn btn-outline-secondary" [disabled]="saving" (click)="cancelChanges()">
                  Cancel
                </button>
                <button type="button" class="btn btn-primary" [disabled]="saving" (click)="saveConfiguration()">
                  <i class="fa fa-save"></i> Save
                </button>
              </div>
            </div>

            <div class="form-grid record-fields">
              <label>
                <span>Key</span>
                <input class="form-control" [(ngModel)]="selectedRecord[keyFieldName]" />
              </label>
              <label>
                <span>Display</span>
                <input class="form-control" [(ngModel)]="selectedRecord[displayFieldName]" />
              </label>
              <div class="option-row full-width">
                <label><input type="checkbox" [(ngModel)]="selectedRecord.IsActive" /> Active</label>
              </div>
            </div>

            <div class="dashboard-tab-designer"
              *ngIf="configurationType === 'dashboard' && editorMode === 'design' && selectedDashboardGroupDefinition">
              <div class="dashboard-tab-context">
                <span>Dashboard group</span>
                <strong>{{ selectedDashboardGroupRecord?.DashboardGroupDisplay }}</strong>
                <button type="button" class="group-settings-button" [disabled]="savingGroup || creatingDashboard"
                  (click)="openDashboardGroupSettings()">
                  <i class="fa fa-cog"></i> Manage tabs
                </button>
              </div>
              <nav class="dashboard-design-tabs" aria-label="Dashboard tabs">
                <button type="button" *ngFor="let tab of selectedDashboardGroupDefinition.tabs"
                  [class.active]="isSelectedDashboardTab(tab)" (click)="selectDashboardTab(tab)">
                  <i *ngIf="tab.iconClass" [class]="tab.iconClass"></i>
                  {{ tab.display }}
                </button>
                <button type="button" class="add-dashboard-tab" [disabled]="creatingDashboard || saving || savingGroup"
                  (click)="openAddDashboardTab()">
                  <i class="fa fa-plus"></i> Add
                </button>
              </nav>
            </div>

            <div class="editor-mode-tabs" *ngIf="configurationType === 'dashboard'">
              <button type="button" [class.active]="editorMode === 'design'" (click)="selectEditorMode('design')">
                <i class="fa fa-th-large"></i> Design
              </button>
              <button type="button" [class.active]="editorMode === 'json'" (click)="selectEditorMode('json')">
                <i class="fa fa-code"></i> JSON
              </button>
            </div>

            <app-report-dashboard-design-canvas
              *ngIf="configurationType === 'dashboard' && editorMode === 'design' && workingDefinition"
              [definition]="workingDefinition"
              [reusableWidgetRecords]="reusableWidgetRecords"
              [expressionContext]="expressionContext"
              [contextNames]="selectedDashboardGroupDefinition?.contextNames || []"
              (definitionChange)="onDefinitionChanged($event)"
              (jsonRequested)="selectEditorMode('json')">
            </app-report-dashboard-design-canvas>

            <label class="json-editor-label" *ngIf="configurationType !== 'dashboard' || editorMode === 'json'">
              <span>Configuration JSON</span>
              <textarea class="form-control code-input dashboard-json-input" rows="28"
                [(ngModel)]="configText" spellcheck="false"></textarea>
            </label>
          </section>

          <section class="preview-card" *ngIf="previewVisible && previewDefinition">
            <div class="preview-toolbar">
              <strong>Live preview</strong>
              <span>Uses the JSON above and current report data.</span>
              <button type="button" class="btn btn-link" (click)="previewVisible = false">Close</button>
            </div>
            <app-report-dashboard [definition]="previewDefinition" [expressionContext]="expressionContext"></app-report-dashboard>
          </section>
        </main>
      </div>
    </div>
  </ng-template>
</dw-router-parent>
